/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Knp_Terms_Saved_Changes_SuccessInputs */

const en_knp_terms_saved_changes_success = /** @type {(inputs: Knp_Terms_Saved_Changes_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Saved ${i?.count} change(s) successfully`)
};

const fr_knp_terms_saved_changes_success = /** @type {(inputs: Knp_Terms_Saved_Changes_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enregistrement réussi de ${i?.count} modification(s)`)
};

const de_knp_terms_saved_changes_success = /** @type {(inputs: Knp_Terms_Saved_Changes_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Änderungen an ${i?.count} erfolgreich gespeichert`)
};

const it_knp_terms_saved_changes_success = /** @type {(inputs: Knp_Terms_Saved_Changes_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Salvate ${i?.count} modifiche con successo`)
};

const ru_knp_terms_saved_changes_success = /** @type {(inputs: Knp_Terms_Saved_Changes_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Изменения ${i?.count} успешно сохранены.`)
};

const es_knp_terms_saved_changes_success = /** @type {(inputs: Knp_Terms_Saved_Changes_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se guardaron ${i?.count} cambios correctamente`)
};

const zh_cn2_knp_terms_saved_changes_success = /** @type {(inputs: Knp_Terms_Saved_Changes_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已成功保存 ${i?.count} 的更改`)
};

const ja_knp_terms_saved_changes_success = /** @type {(inputs: Knp_Terms_Saved_Changes_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 件の変更が正常に保存されました`)
};

const hi_knp_terms_saved_changes_success = /** @type {(inputs: Knp_Terms_Saved_Changes_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} परिवर्तन सफलतापूर्वक सहेजे गए`)
};

const pt_pt2_knp_terms_saved_changes_success = /** @type {(inputs: Knp_Terms_Saved_Changes_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alterações ${i?.count} salvas com sucesso`)
};

/**
* | output |
* | --- |
* | "Saved {count} change(s) successfully" |
*
* @param {Knp_Terms_Saved_Changes_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_saved_changes_success = /** @type {((inputs: Knp_Terms_Saved_Changes_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Saved_Changes_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_saved_changes_success(inputs)
	if (locale === "de") return de_knp_terms_saved_changes_success(inputs)
	if (locale === "it") return it_knp_terms_saved_changes_success(inputs)
	if (locale === "ru") return ru_knp_terms_saved_changes_success(inputs)
	if (locale === "es") return es_knp_terms_saved_changes_success(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_saved_changes_success(inputs)
	if (locale === "ja") return ja_knp_terms_saved_changes_success(inputs)
	if (locale === "hi") return hi_knp_terms_saved_changes_success(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_saved_changes_success(inputs)
	return en_knp_terms_saved_changes_success(inputs)
});